/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Connection_LostInputs */



/**
* | output |
* | --- |
* | "The connection to the server was lost. Reload the page — the response may have been saved anyway." |
*
* @param {Chat_Error_Connection_LostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_connection_lost = /** @type {((inputs?: Chat_Error_Connection_LostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Connection_LostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Verbindung zum Server wurde unterbrochen. Lade die Seite neu — die Antwort wurde möglicherweise trotzdem gespeichert.")
	return /** @type {LocalizedString} */ ("The connection to the server was lost. Reload the page — the response may have been saved anyway.")
});